import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { withRouter, Route, Redirect } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

import store from 'root/admin/store';

@observer
export default class Award extends React.Component {
	render() {
		const rootPath = '/admin';

		return (
			<div>
				<Route exact path={`${rootPath}/awards`} component={() => <List rootPath={rootPath} />} />
				<Route path={`${rootPath}/awards/:id`} component={() => <Edit rootPath={rootPath} />} />
			</div>
		);
	}
}
